import { Component, Input } from '@angular/core';
import { CardModel } from '@pedix-workspace/angular-ui-payment';
import { InteractivePaycardComponent } from '@pedix-workspace/angular-ui-payment';

@Component({
    selector: 'pxw-argentine-payment',
    templateUrl: './argentine-payment.component.html',
    styleUrls: ['./argentine-payment.component.scss'],
    imports: [InteractivePaycardComponent]
})
export class ArgentinePaymentComponent {
  @Input() cardModel: CardModel;
  @Input() showCreditCard = true;
}
